import { ResultStatus } from '@dispatch/shared/types';
import { Box, Stack, Typography } from '@mui/material';
import { CSSProperties } from 'react';
import { ReactComponent as BlobImage } from './assets/bg_blob.svg';
import { ReactComponent as NoResultsImage } from './assets/noresults.svg';
import { ReactComponent as TeamSpiritImage } from './assets/team_spirit.svg';
import { ReactComponent as UsersImage } from './assets/users.svg';

type EmptyVariant = 'default' | 'user';
export type EmptyProps = {
  entityName: string;
  status?: ResultStatus;
  variant?: EmptyVariant;
};

const svgStyles: CSSProperties = {
  maxWidth: '20em',
  maxHeight: '20em',
  position: 'absolute',
};

export function Empty({
  entityName,
  status = 'empty',
  variant = 'default',
}: EmptyProps) {
  function EmptyState() {
    return (
      <>
        <Typography variant="h5" color="primary" data-testid="table-empty-text">
          Add your first {entityName} to get started
        </Typography>
        <Box sx={{ position: 'absolute' }}>
          <BlobImage style={{ opacity: 0.8 }} />
        </Box>
        {variant === 'default' && (
          <TeamSpiritImage
            style={svgStyles}
            data-testid="table-empty-image-team"
          />
        )}
        {variant === 'user' && (
          <UsersImage style={svgStyles} data-testid="table-empty-image-user" />
        )}
      </>
    );
  }

  function NoResultsState() {
    return (
      <>
        <Typography variant="h5" color="primary">
          Sorry! No Result Found
        </Typography>
        <Box sx={{ position: 'absolute' }}>
          <BlobImage style={{ opacity: 0.8, marginTop: '2em' }} />
        </Box>
        <NoResultsImage
          style={{ ...svgStyles, marginTop: '2em' }}
          data-testid="table-empty-image-noresults"
        />
      </>
    );
  }
  return (
    <Stack
      direction="column"
      spacing={2}
      alignItems="center"
      p={5}
      mb={2}
      data-testid="empty-container"
    >
      {status === 'empty' && <EmptyState />}
      {status === 'noresult' && <NoResultsState />}
    </Stack>
  );
}
